// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getMessaging, getToken, deleteToken, onMessage, isSupported } from "firebase/messaging";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBK440MI3XsCCTu9bTT9qWDkPi8tY_Wv68",
  authDomain: "safemap-dev-260b1.firebaseapp.com",
  projectId: "safemap-dev-260b1",
  storageBucket: "safemap-dev-260b1.firebasestorage.app",
  messagingSenderId: "769842771521",
  appId: "1:769842771521:web:b8aa06a10f63747cac38c0"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const messagingPromise = isSupported()
  .then((supported) => supported ? getMessaging(app) : null)
  .catch(() => null);

export { messagingPromise, getToken, deleteToken, onMessage };
//BOAeFgEYpRbkmty6TvqJ046p-u4Qu1RRS1wmxWPv0ZAK3EXMpbDTXeNsbm59whFAvX0duqoBMmqNiEykCe6H3DA
